import type { BrandPack } from '../brand-pack';
import * as palette from './palette';
import { LogoGlyph } from './LogoGlyph';
import { LogoMark } from './LogoMark';
import { rpColors, rpRgb } from './roleplay-palette';
import { landingColors, LANDING_CSS_VARS, landingGradients } from './landing-palette';

export const brand = {
  id: 'default',
  appName: 'InsuCoach',
  tagline: 'AI Roleplay Platform',
  documentAuthor: 'AI Sales Coach',
  bootTitleHighlight: 'Coach',
  supportsDarkMode: true,
  palette,
  roleplay: { colors: rpColors, rgb: rpRgb },
  landing: { colors: landingColors, cssVars: LANDING_CSS_VARS, gradients: landingGradients },
  components: { LogoMark, LogoGlyph },
} satisfies BrandPack;
